import { Box } from '@mui/material';

import SupportCards from '../../components/SupportCards/SupportCards';
import './Support.scss';
import KeyResourceCards from '../../components/KeyResourceCards/KeyResourceCards';
import SupportBreadCrumbs from '../../components/SupportBreadcrumbs/SupportBreadcrumbs';

const Support = () => {
  return (
    <Box className="supportPageContainer">
      <Box className="supportContentContainer">
        <SupportBreadCrumbs></SupportBreadCrumbs>
      </Box>

      <main>
        <Box className="supportContentContainer">
          <SupportCards />
        </Box>

        <section className="vertical-spacing bgcolor">
          <Box className="supportContentContainer">
            <KeyResourceCards></KeyResourceCards>
          </Box>
        </section>
      </main>
    </Box>
  );
};

export default Support;
